var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFedex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 36,
    viewBox: "0 0 116 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1072_2982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.2308 12.6387L100.951 17.8506L105.495 12.6387H115.199L105.716 23.323L115.329 34.0944H105.234L100.558 28.8413L95.9249 34.0944H86.1768L95.7062 23.3674L86.1768 12.6387H96.2308Z",
    fill: "#FF5900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1782 12.639V19.8883H75.3854V26.5406H86.1782V34.0948H67.4537V0.296875H86.1782V7.83047H75.3854V12.639H86.1782Z",
    fill: "#FF5900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5539 0.296875V14.1286H59.4666C57.7167 12.115 55.5324 11.4146 52.9981 11.4146C47.8053 11.4146 43.8933 14.9528 42.5207 19.6279C40.9531 14.4764 36.9144 11.3178 30.926 11.3178C26.063 11.3178 22.2224 13.5045 20.2189 17.0681V12.639H10.1664V7.83047H21.1367V0.296875H1.20605V34.0948H10.1664V19.8883H19.0982C18.832 20.9316 18.6893 22.0497 18.6893 23.2295C18.6893 30.2788 24.0659 35.2271 30.926 35.2271C36.6956 35.2271 40.4982 32.5132 42.5081 27.5665H34.8283C33.7902 29.0544 33.0024 29.4943 30.926 29.4943C28.5182 29.4943 26.4419 27.3901 26.4419 24.8953H42.0784C42.7569 30.4948 47.1111 35.3239 53.0852 35.3239C55.6625 35.3239 58.0226 34.0535 59.465 31.9097H59.5522V34.0979H67.4507V0.296875H59.5539ZM26.6923 19.9884C27.1901 17.8413 28.8528 16.4392 30.9276 16.4392C33.2116 16.4392 34.7887 17.7985 35.2041 19.9884C35.3784 19.9884 26.6923 19.9884 26.6923 19.9884ZM54.759 28.9496C51.8473 28.9496 50.0371 26.2309 50.0371 23.3931C50.0371 20.36 51.6111 17.4428 54.759 17.4428C58.0226 17.4428 59.3224 20.36 59.3224 23.3931C59.3224 26.269 57.9449 28.9496 54.759 28.9496Z",
    fill: "#2A007C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1072_2982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114.811,
    height: 36,
    fill: "white",
    transform: "translate(0.862061)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFedex);
export default __webpack_public_path__ + "static/media/fedex.125c6e1c49a4aec9eec17476dffd9973.svg";
export { ForwardRef as ReactComponent };